module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/share-mobile.8a40e5d3.svg";